import { Stack } from "@mantine/core";

import ProceduresSection from "./components/ProceduresSection";

interface ProceduresTabProps {
  isEncounterActive: boolean;
  isAmendment?: boolean;
}

function ProceduresTab({ isEncounterActive, isAmendment = false }: ProceduresTabProps) {
  return (
    <Stack py="xl" gap="xl">
      <ProceduresSection isAmendment={isAmendment} isEncounterActive={isEncounterActive} />
    </Stack>
  );
}

export default ProceduresTab;
